import addTOTPMethod from './addTOTPMethod';
import addWebAuthnMethod from './addWebAuthnMethod';
import getCredsWebAuthnMethod from './getCredsWebAuthnMethod';
import getMFAMethods from './getMFAMethods';
import getVerificationMFACode from './getVerificationMFACode';
import loginWebAuthnMethod from './loginWebAuthnMethod';
import toggleMFA from './toggleMFA';

const MFARequests = {
	getVerificationMFACode,
	getCredsWebAuthnMethod,
	loginWebAuthnMethod,
	addWebAuthnMethod,
	addTOTPMethod,
	getMFAMethods,
	toggleMFA,
};

export default MFARequests;
